import React from 'react';
import Script from 'next/script';

import { IOutgrowFields } from '@/types/contentful';

export default function Popup({ code, iframeId }: Partial<IOutgrowFields>) {
  return (
    <>
      {code && (
        <div
          dangerouslySetInnerHTML={{ __html: code || '' }}
          data-testid="outgrow-popup"
        />
      )}
      <Script
        id="outgrow-popup"
        strategy="afterInteractive"
      >{`var og_temp=document.createElement('script');og_temp.async=true;og_temp.defer=true;og_temp.src='//dyv6f9ner1ir9.cloudfront.net/assets/js/nploaderV2.js',og_temp.onload=function(){initIframe('${iframeId}')},document.querySelector('head').appendChild(og_temp)`}</Script>
    </>
  );
}
